import CarVideoContainer from "../../../components/car/detail/CarVideo";

const CarVideo = () => {
  return <CarVideoContainer />;
};

export default CarVideo;
